import React from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import PropTypes from "prop-types";
import Header03 from "../components/header/Header03";
import MobileHeader from "../components/header/MobileHeader";
import Banner07 from "../components/banner/Banner07";
import Category07 from "../components/category/Category07";
import dataCate from "../assets/fakeData/dataCategory";
import Job07 from "../components/jobs/Job07";
import dataJobs from "../assets/fakeData/dataJobs";
import Location from "../components/location";
import dataLocation from "../assets/fakeData/dataLocation";

import Box07 from "../components/boxicon/Box07";
import Couter from "../components/iconbox/Couter";
import Blog01 from "../components/blog/Blog01";
import dataBlog from "../assets/fakeData/dataBlog";
import Partner from "../components/partner";
import dataPartner from "../assets/fakeData/dataPartner";
import Footer from "../components/footer";
import Gotop from "../components/gotop";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../assets/images/logo.png";

import httpService from "../services/httpService";

Home_v7.propTypes = {};

function Home_v7(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);
  const [categories, setCategories] = useState([]);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();

    getCategories();
  }, []);

  const getCategories = async () => {
    try {
      const res = await httpService.get(`/news/categories`);
      setCategories(res.data.data);
    } catch (error) { }
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>UKICNEWS - About Us | We are your go-to source for the latest UK Immigration News</title>
          <meta
            name="description"
            content="Stay updated with the latest UK immigration news, visa changes, sponsorship jobs, and clear policy explanation for Business, Family Sponsorship, study, work, visit, ILR and more. UKICNEWS delivers trusted and timely immigration updates."
          />
          <link rel="canonical" href="https://www.ukicnews.com/about-us" />

          {/* Open Graph (Facebook / LinkedIn preview) */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content="UKICNEWS | About Us" />
          <meta
            property="og:description"
            content="Get reliable UK immigration updates, visa news, and sponsorship job opportunities."
          />
          <meta property="og:url" content="https://www.ukicnews.com/about-us" />
          <meta property="og:image" content="https://www.ukicnews.com/preview.png" />

          {/* Twitter preview */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="UKICNEWS | About Us" />
          <meta
            name="twitter:description"
            content="Stay updated with UK immigration rules and sponsorship jobs."
          />
          <meta name="twitter:image" content="https://www.ukicnews.com/preview.png" />
        </Helmet>
      </HelmetProvider>
      <MobileHeader handleMobile={handleMobile} />
      <Header03 clname="act1" handleMobile={handleMobile} />
      <Banner07 />
      <Category07 data={categories} />
      <Box07 />
      {/* <Partner data={dataPartner} /> */}
      <Footer />
      <Gotop />
    </>
  );
}

export default Home_v7;
